<template>
  <div class="result-image-container">
    <ResultImage
      :image="resultImage"
      :isActive="
        [
          Routes.result.name,
          Routes.register.name,
          Routes.completion.name
        ].includes(currentRoute)
      "
      :zoomIn="
        [Routes.register.name, Routes.completion.name].includes(currentRoute)
      "
      :zoomIn2="[Routes.completion.name].includes(currentRoute)"
      :move="scrollContentPosition"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Routes } from "@/constants";
import config from "@/api/config";

import ResultImage from "@/components/ResultImage";

export default {
  name: "ResultImageContainer",
  components: {
    ResultImage
  },
  data() {
    return {
      Routes: Routes
    };
  },
  computed: {
    currentRoute: function() {
      return this.$route.name;
    },
    ...mapState({
      resultImage: state => config.STORAGE_URL + state.resultImage,
      scrollContentPosition: state => state.scrollContentPosition
    })
  }
};
</script>

<style lang="scss" scoped>
.result-image-container {
  display: block;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: z-index("underground");
}
</style>
